import { format, parseISO } from 'date-fns'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useUkTimeZone } from '../../../hooks'
import { SearchItem } from '../../Search'
import { EmailPriorityTag } from '../EmailPriorityTag'

import {
  EMAIL_SEARCH_ITEM_DATE_FORMAT,
  EMAIL_SEARCH_ITEM_ICON,
} from './EmailSearchItem.constants'

import * as styles from './EmailSearchItem.module.css'

function EmailSearchItem({ className = styles.EmailSearchItem, value }) {
  const {
    archived,
    created,
    is_high_priority: isHighPriority,
    subject,
  } = value.item ?? EMPTY_OBJECT

  const { locale } = useUkTimeZone()

  const additional = [
    format(parseISO(created), EMAIL_SEARCH_ITEM_DATE_FORMAT, { locale }),
  ]

  return (
    <SearchItem
      additional={additional}
      archived={archived}
      className={className}
      icon={EMAIL_SEARCH_ITEM_ICON}
      status={isHighPriority ? <EmailPriorityTag /> : null}
      title={subject}
    />
  )
}

export default EmailSearchItem
